export default __webpack_public_path__ + "static/media/great_job.67c6ac1d.mp3";